import { Property } from 'csstype';

type Props = {
  gridTemplateColumns?: Property.GridTemplateColumns;
  gridAutoRows?: Property.GridAutoRows;
};

const gridInterpolations = {
  gridTemplateColumns: ({ gridTemplateColumns }: Pick<Props, 'gridTemplateColumns'>) =>
    gridTemplateColumns === undefined
      ? {}
      : {
          gridTemplateColumns
        },
  gridAutoRows: ({ gridAutoRows }: Pick<Props, 'gridAutoRows'>) =>
    gridAutoRows === undefined
      ? {}
      : {
          gridAutoRows
        }
};

export { gridInterpolations };

export type GridProps = Props;
